import { useId } from 'react';

const fieldLabelStyle = {
  display: "block",
  fontSize: 11,
  fontWeight: 600,
  color: "#6b7280",
  marginBottom: 4,
};

export default function FormField({ label, children, id: externalId, error }) {
  const autoId = useId();
  const fieldId = externalId || autoId;
  return (
    <div style={{ marginBottom: 10 }}>
      <label htmlFor={fieldId} style={fieldLabelStyle}>{label}</label>
      {children}
      {error && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 4 }}>{String(error)}</div>}
    </div>
  );
}

export { fieldLabelStyle };
